import React, { Component } from 'react';
// Librairies
import { connect } from 'react-redux';
import { setProject, setProjects, setProjectCollaborators, setUserProjects, setRootBaseProjectIds } from '../../actionCreators/projectsActions';
import { setPhotosGalleries, setFilesGalleries } from '../../actionCreators/elementsActions';
import { setFilterLists, setCustomCharts } from '../../actionCreators/componentsActions';
import { setActiveOrganization, setCustomFieldCategories, setOrganizationCustomFields, setOrganizations, setPriceLists, setThemes } from '../../actionCreators/usersActions';
import { jwtDecode } from 'jwt-decode';
import Cookies from 'universal-cookie';
// Utils
import RealtimeUtil, { REALTIME_ENTITIES } from '../../utils/RealtimeUtil';
import FileInfosUtil from '../../utils/FileInfosUtil';
import ProjectsUtil from '../../utils/ProjectsUtil';
import { showToast } from '../../utils/ToastsUtil';

class GlobalWebSocket extends Component {
    render() {
        return (<></>);
    }

    componentDidMount = () => {
        this.publicFields = ProjectsUtil.getProjectPublicFields(this.props.project, this.props.projectCollaborators || []);
        // Fichiers d'un élément : groupe du projet (rejoint par ProjectWebSocket) ; fichiers d'un projet : groupe de l'utilisateur
        this.realtimeUnsubscribers = [
            RealtimeUtil.subscribe(REALTIME_ENTITIES.fileInfos, (op, data) => {
                if (op === 'removed') this.handleRemoveFileInfos(data);
                else if (op === 'created') this.handleSendFileInfos(data);
                else this.handleUpdateFileInfos(data);
            }),
            RealtimeUtil.subscribe(REALTIME_ENTITIES.tags, (_, tags, { projectId }) => this.handleTags(projectId, tags)),
            RealtimeUtil.subscribe(REALTIME_ENTITIES.projectLogs, (_, projectLogs, { projectId }) => {
                if (this.props.project?.id === projectId && ProjectsUtil.isUserInProject(this.props.projectCollaborators)) this.addOrUpdateProjectLog(projectLogs);
            }),
            RealtimeUtil.subscribe(REALTIME_ENTITIES.stationElements, (_, stationElementResult, { projectId }) => {
                if (this.props.project?.id === projectId && ProjectsUtil.isUserInProject(this.props.projectCollaborators)) this.handleStationElementResult(stationElementResult);
            }),
            // Projets et dossiers : groupe de l'utilisateur (collaborateurs) ; éléments liés : groupe du projet
            RealtimeUtil.subscribe(REALTIME_ENTITIES.project, (_, data) => this.handleProjectUpdated(data)),
            RealtimeUtil.subscribe(REALTIME_ENTITIES.baseProjects, (op, data) => {
                if (op === 'created') this.handleBaseProjectsCreated(data);
                else if (op === 'updated') this.handleBaseProjectsMoved(data);
                else this.handleBaseProjectsRemoved(data);
            }),
            RealtimeUtil.subscribe(REALTIME_ENTITIES.userBaseProjects, (_, data) => this.handleUserBaseProjects(data)),
            RealtimeUtil.subscribe(REALTIME_ENTITIES.projectRoles, (_, data) => this.handleProjectRoles(data)),
            RealtimeUtil.subscribe(REALTIME_ENTITIES.filters, (op, data, { projectId }) => this.handleProjectList('filterLists', op, data, projectId)),
            RealtimeUtil.subscribe(REALTIME_ENTITIES.customCharts, (op, data, { projectId }) => this.handleProjectList('customCharts', op, data, projectId)),
            // Organisations : groupe de chaque membre
            RealtimeUtil.subscribe(REALTIME_ENTITIES.organization, (op, data) => op === 'removed' ? this.handleOrganizationRemoved(data) : this.handleOrganizationUpdated(data)),
            RealtimeUtil.subscribe(REALTIME_ENTITIES.userOrganizations, (op, data) => this.handleUserOrganizations(op, data)),
            RealtimeUtil.subscribe(REALTIME_ENTITIES.organizationInvitations, (op, data) => this.handleOrganizationInvitations(op, data)),
            RealtimeUtil.subscribe(REALTIME_ENTITIES.themes, (op, data) => this.handleOrganizationList('themes', 'setThemes', op, data)),
            RealtimeUtil.subscribe(REALTIME_ENTITIES.priceLists, (op, data) => this.handleOrganizationList('priceLists', 'setPriceLists', op, data)),
            RealtimeUtil.subscribe(REALTIME_ENTITIES.customFields, (op, data) => this.handleOrganizationList('organizationCustomFields', 'setOrganizationCustomFields', op, data)),
            RealtimeUtil.subscribe(REALTIME_ENTITIES.customFieldCategories, (op, data) => this.handleCustomFieldCategories(op, data))
        ];
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.projectCollaborators !== this.props.projectCollaborators)
            this.publicFields = ProjectsUtil.getProjectPublicFields(this.props.project, this.props.projectCollaborators);
        if (prevProps.project !== this.props.project)
            this.publicFields = ProjectsUtil.getProjectPublicFields(this.props.project, this.props.projectCollaborators);
    }

    componentWillUnmount = () => {
        this.realtimeUnsubscribers.forEach(unsubscribe => unsubscribe());
    }

    handleOrganizationUpdated = (organization) => {
        const { organizations, activeOrganization } = this.props;
        if (organizations?.find(o => o.id === organization.id)) this.props.setOrganizations(organizations.map(o => o.id === organization.id ? { ...o, ...organization } : o));
        if (activeOrganization?.id === organization.id) this.props.setActiveOrganization({ ...activeOrganization, ...organization });
    }

    // L'utilisateur a été retiré de l'organisation (ou l'a quittée depuis un autre onglet)
    handleOrganizationRemoved = (organizationId) => {
        const { organizations, activeOrganization } = this.props;
        if (activeOrganization?.id !== organizationId && organizations) this.props.setOrganizations(organizations.filter(o => o.id !== organizationId));
    }

    handleUserOrganizations = (op, { organizationId, users, userIds }) => {
        const { activeOrganization } = this.props;
        if (activeOrganization?.id !== organizationId) return;
        const linkedUsers = activeOrganization.linkedUsers || [], userOrganizations = activeOrganization.userOrganizations || [];

        if (op === 'removed') this.props.setActiveOrganization({
            ...activeOrganization,
            linkedUsers: linkedUsers.filter(lu => !userIds.includes(lu.id)),
            userOrganizations: userOrganizations.filter(uo => !userIds.includes(uo.userId))
        });
        else {
            const addedUsers = users.filter(user => !linkedUsers.find(lu => lu.id === user.id)).map(user => ({ ...user, organizationId }));
            this.props.setActiveOrganization({ ...activeOrganization, linkedUsers: [...linkedUsers, ...addedUsers], userOrganizations: [...userOrganizations, ...addedUsers] });
        }
    }

    handleOrganizationInvitations = (op, { organizationId, invitations, ids }) => {
        const { activeOrganization } = this.props;
        if (activeOrganization?.id !== organizationId) return;
        const currentInvitations = activeOrganization.invitations || [];
        this.props.setActiveOrganization({
            ...activeOrganization,
            invitations: op === 'removed'
                ? currentInvitations.filter(i => !ids.includes(i.id))
                : [...currentInvitations.filter(i => !invitations.find(invitation => invitation.email === i.email)), ...invitations]
        });
    }

    // Thèmes, listes de prix et champs personnalisés de l'organisation active
    handleOrganizationList = (key, setter, op, data) => {
        const list = this.props[key];
        if (!list) return; // Pas encore chargée : elle le sera à l'ouverture
        if (op === 'removed') this.props[setter](list.filter(item => !data.includes(item.id)));
        else if (data.length && data[0].organizationId === this.props.activeOrganization?.id) {
            if (op === 'created') this.props[setter]([...list, ...data.filter(item => !list.find(i => i.id === item.id))]);
            else this.props[setter](list.map(item => data.find(updatedItem => updatedItem.id === item.id) || item));
        }
    }

    // Catégories de champs personnalisés, rangées par organisation dans le store
    handleCustomFieldCategories = (op, data) => {
        const { customFieldCategories } = this.props;
        if (!customFieldCategories) return;
        if (op === 'removed') {
            const organizationId = Object.keys(customFieldCategories).find(key => customFieldCategories[key]?.find(cfc => data.includes(cfc.id)));
            if (organizationId) this.props.setCustomFieldCategories(Number(organizationId), customFieldCategories[organizationId].filter(cfc => !data.includes(cfc.id)));
            return;
        }

        const organizationId = data[0]?.organizationId;
        const list = customFieldCategories[organizationId];
        if (!list) return;
        if (op === 'created') this.props.setCustomFieldCategories(organizationId, [...list, ...data.filter(cfc => !list.find(c => c.id === cfc.id))]);
        else this.props.setCustomFieldCategories(organizationId, list.map(cfc => data.find(updatedCategory => updatedCategory.id === cfc.id) || cfc));
    }

    // Champs modifiés d'un projet ou d'un dossier (toujours avec son id), fusionnés dans le projet ouvert et la liste
    handleProjectUpdated = (data) => {
        const { project, projects, projectCollaborators } = this.props;
        // Le client qui modifie envoie les relations (collaborateurs, rôles…) à null : elles ne doivent pas écraser celles déjà chargées
        const merge = (baseProject) => ({ ...baseProject, ...Object.fromEntries(Object.entries(data).filter(([key, value]) => value !== null || typeof baseProject[key] !== 'object')) });
        if (projects?.find(p => p.id === data.id)) this.props.setProjects(projects.map(p => p.id === data.id ? merge(p) : p));
        if (project?.id !== data.id) return;

        const updatedProject = merge(project);
        ProjectsUtil.assignProjectFormulaVersionsType(updatedProject, this.props.formulas);
        this.props.setProject(updatedProject);
        if (data.userBaseProjects?.length && projectCollaborators)
            this.props.setProjectCollaborators([...projectCollaborators.filter(pc => pc.baseProjectId !== data.id), ...data.userBaseProjects.filter(ubp => ubp.baseProjectId === data.id)]);
    }

    // Racine de la liste : sans dossier parent, ou dont le dossier parent n'est pas chargé
    getRootBaseProjectIds = (baseProjects, rootBaseProjectIds, changedBaseProjects) => {
        const changedIds = changedBaseProjects.map(bp => bp.id);
        const newRootIds = changedBaseProjects.filter(bp => !bp.parentFolderId || !baseProjects.find(p => p.id === bp.parentFolderId)).map(bp => bp.id);
        return [...rootBaseProjectIds.filter(id => !changedIds.includes(id)), ...newRootIds];
    }

    handleBaseProjectsCreated = (baseProjects) => {
        const { projects, rootBaseProjectIds, project } = this.props;
        if (!projects) return;
        const newBaseProjects = baseProjects.filter(bp => bp && !projects.find(p => p.id === bp.id));
        if (!newBaseProjects.length) return;
        const updatedProjects = [...projects, ...newBaseProjects];
        this.props.setProjects(updatedProjects);
        this.props.setRootBaseProjectIds(this.getRootBaseProjectIds(updatedProjects, rootBaseProjectIds || [], newBaseProjects));
        if (project && newBaseProjects.find(bp => bp.id === project.id)) RealtimeUtil.refreshProject(project.id); // Droits de collaborateur et verrous
    }

    // Déplacement : nouveaux parentFolderId, path et organizationId
    handleBaseProjectsMoved = (movedBaseProjects) => {
        const { projects, rootBaseProjectIds } = this.props;
        if (!projects) return;
        const movedIds = movedBaseProjects.map(bp => bp.id);
        const updatedProjects = projects.map(p => movedIds.includes(p.id) ? { ...p, ...movedBaseProjects.find(bp => bp.id === p.id) } : p);
        this.props.setProjects(updatedProjects);
        this.props.setRootBaseProjectIds(this.getRootBaseProjectIds(updatedProjects, rootBaseProjectIds || [], updatedProjects.filter(p => movedIds.includes(p.id))));
    }

    handleBaseProjectsRemoved = (ids) => {
        const { projects, rootBaseProjectIds, project, projectCollaborators, userProjects } = this.props;
        if (projects) this.props.setProjects(projects.filter(bp => !ids.includes(bp.id)));
        if (rootBaseProjectIds) this.props.setRootBaseProjectIds(rootBaseProjectIds.filter(id => !ids.includes(id)));

        // Projet ouvert (ou un de ses dossiers parents) : l'utilisateur n'en fait plus partie.
        // ProjectMap redirige vers l'accueil quand userProjects ne le contient plus et que le projet n'est pas public (le routeur n'est pas accessible ici)
        if (project && ids.find(id => id === project.id || project.path?.includes(`/${id}/`))) {
            const userId = new Cookies().get('token') ? jwtDecode(new Cookies().get('token'))?.id : null;
            const collaborators = (projectCollaborators || []).filter(pc => pc.userId !== userId);
            if (!project.isPublic) showToast('project_access_lost');
            this.props.setUserProjects(userProjects ? userProjects.filter(up => up.userId !== userId) : collaborators);
            this.props.setProjectCollaborators(collaborators);
            this.props.setProject({ ...project, userBaseProjects: (project.userBaseProjects || []).filter(ubp => ubp.userId !== userId) });
        }
    }

    // Droits portés par un projet ou un dossier : remplacent ceux du projet ouvert et de la liste (y compris des sous-projets)
    handleUserBaseProjects = ({ baseProjectId, userBaseProjects }) => {
        const { project, projects, projectCollaborators } = this.props;
        const isConcerned = (bp) => bp.id === baseProjectId || bp.path?.includes(`/${baseProjectId}/`);
        const replace = (ubps) => [...(ubps || []).filter(ubp => ubp.baseProjectId !== baseProjectId), ...userBaseProjects];

        if (projects?.find(isConcerned)) this.props.setProjects(projects.map(bp => isConcerned(bp) ? { ...bp, userBaseProjects: replace(bp.userBaseProjects) } : bp));
        if (project && isConcerned(project)) {
            this.props.setProject({ ...project, userBaseProjects: replace(project.userBaseProjects) });
            if (projectCollaborators) this.props.setProjectCollaborators(replace(projectCollaborators));
            RealtimeUtil.refreshProject(project.id); // Les droits de l'utilisateur ont pu changer : verrous
        }
    }

    handleProjectRoles = ({ baseProjectId, projectRoles }) => {
        const { project, projects, projectCollaborators } = this.props;
        const withRoles = (ubps) => (ubps || []).map(ubp => ubp.baseProjectId === baseProjectId ? { ...ubp, projectRole: projectRoles.find(pr => pr.id === ubp.projectRoleId) || ubp.projectRole } : ubp);

        if (projects?.find(bp => bp.id === baseProjectId))
            this.props.setProjects(projects.map(bp => bp.id === baseProjectId ? { ...bp, projectRoles, userBaseProjects: withRoles(bp.userBaseProjects) } : bp));
        if (project?.id === baseProjectId) {
            this.props.setProject({ ...project, projectRoles, userBaseProjects: withRoles(project.userBaseProjects) });
            if (projectCollaborators) this.props.setProjectCollaborators(withRoles(projectCollaborators));
        }
    }

    // Filtres et graphiques personnalisés d'un projet, rangés par projet dans le store
    handleProjectList = (key, op, data, projectId) => {
        const lists = this.props[key];
        if (!lists?.[projectId]) return; // Pas encore chargés : ils le seront à l'ouverture
        let list = lists[projectId];
        if (op === 'removed') list = list.filter(item => !data.includes(item.id));
        else if (op === 'updated') list = list.map(item => item.id === data.id ? data : item);
        else if (!list.find(item => item.id === data.id)) list = [...list, data];
        this.props[key === 'filterLists' ? 'setFilterLists' : 'setCustomCharts']({ ...lists, [projectId]: list });
    }

    // Liste complète des tags d'un projet
    handleTags = (projectId, tags) => {
        if (this.props.project?.id === projectId) this.props.setProject({ ...this.props.project, tags });
        const baseProject = this.props.projects?.find(p => p.id === projectId);
        if (baseProject) this.props.setProjects(this.props.projects.map(p => p.id === projectId ? { ...p, tags } : p));
    }

    addOrUpdateProjectLog = (projectLogs) => {
        if (!this.props.project.projectLogs) return; // Historique pas encore chargé : il le sera en entier à l'ouverture
        let project = JSON.parse(JSON.stringify(this.props.project));
        projectLogs.forEach(projectLog => {
            const projectLogInLocal = project.projectLogs.find(x => x.id === projectLog.id);
            if (!projectLogInLocal) project.projectLogs.push(projectLog);
            else if (!projectLogInLocal.status && !projectLogInLocal.Status) project.projectLogs[project.projectLogs.indexOf(projectLogInLocal)] = projectLog;
        });
        this.props.setProject(project);
    }

    handleStationElementResult = (stationElementResult) => {
        const { stationElementsAdded, stationElementsUpdated, stationElementsDeleted } = stationElementResult;
        // Sans changement, ne pas réécrire le projet : un message reçu juste avant (historique…) n'est pas encore dans les props
        if (!stationElementsAdded?.length && !stationElementsUpdated?.length && !stationElementsDeleted?.length) return;
        if (!this.props.project?.stationElements) return;

        // Map indexée par la clé du lien : une recherche par lien reçu (some/findIndex) parcourait toute la liste à chaque fois
        // et figeait l'interface sur un gros lot. Copie superficielle du projet : seule la liste des liens change.
        const getKey = (se) => `${se.projectId}|${se.stationId}|${se.elementId}|${se.category}`;
        const stationElements = new Map(this.props.project.stationElements.map(se => [getKey(se), se]));
        stationElementsDeleted?.forEach(se => stationElements.delete(getKey(se)));
        stationElementsAdded?.forEach(se => stationElements.set(getKey(se), se));
        stationElementsUpdated?.forEach(se => stationElements.set(getKey(se), se));

        this.props.setProject({ ...this.props.project, stationElements: [...stationElements.values()] });
    };

    isFileInfoVisible = (type) => !this.props.project || !!this.publicFields?.main[type === 'photo' ? 'photos' : 'files'];

    handleSendFileInfos = (fileInfosParsed) => {
        const type = fileInfosParsed[0].type;
        if (!this.isFileInfoVisible(type)) return;

        if (this.props.project && type === 'photo') {
            let photosGalleries = [...this.props.photosGalleries];
            fileInfosParsed.forEach(fileInfoParsed => {
                const index = photosGalleries.findIndex(x => x.blobName === fileInfoParsed.blobName || x.id === fileInfoParsed.id);
                if (index === -1) {
                    fileInfoParsed.url = FileInfosUtil.getUrl(fileInfoParsed);
                    photosGalleries.push(fileInfoParsed);
                }
            });
            this.props.setPhotosGalleries(photosGalleries);
        } else if (this.props.project && fileInfosParsed[0].elementId) {
            let filesGalleries = [...this.props.filesGalleries];
            fileInfosParsed.forEach(fileInfoParsed => {
                const index = filesGalleries.findIndex(x => x.blobName === fileInfoParsed.blobName || x.id === fileInfoParsed.id);
                if (index === -1) {
                    fileInfoParsed.url = FileInfosUtil.getUrl(fileInfoParsed);
                    filesGalleries.push(fileInfoParsed);
                }
            });
            this.props.setFilesGalleries(filesGalleries);
        } else if (!fileInfosParsed[0].elementId) {
            const addMissing = (fileInfos) => [...fileInfos || [], ...fileInfosParsed.filter(fi => !fileInfos?.find(x => x.id === fi.id))];
            if (this.props.project?.id === fileInfosParsed[0].projectId) {
                let project = JSON.parse(JSON.stringify(this.props.project));
                project.fileInfos = addMissing(project.fileInfos);
                this.props.setProject(project);
            }

            if (this.props.projects?.length) {
                let projects = JSON.parse(JSON.stringify(this.props.projects));
                const index = projects.findIndex(x => x.id === fileInfosParsed[0].projectId);
                if (index !== -1) projects[index].fileInfos = addMissing(projects[index].fileInfos);
                this.props.setProjects(projects);
            }
        }
    }

    handleUpdateFileInfos = (fileInfosParsed) => {
        const type = fileInfosParsed[0].type;
        if (!this.isFileInfoVisible(type)) return;

        if (this.props.project && type === 'photo') {
            let photosGalleries = [...this.props.photosGalleries];
            fileInfosParsed.forEach(fileInfoParsed => {
                const index = photosGalleries.findIndex(x => x.id === fileInfoParsed.id);
                if (index !== -1) {
                    fileInfoParsed.url = FileInfosUtil.getUrl(fileInfoParsed);
                    photosGalleries[index] = fileInfoParsed;
                }
            });
            this.props.setPhotosGalleries(photosGalleries);
        } else if (this.props.project && fileInfosParsed[0].elementId) {
            let filesGalleries = [...this.props.filesGalleries];
            fileInfosParsed.forEach(fileInfoParsed => {
                const index = filesGalleries.findIndex(x => x.id === fileInfoParsed.id);
                if (index !== -1) {
                    fileInfoParsed.url = FileInfosUtil.getUrl(fileInfoParsed);
                    filesGalleries[index] = fileInfoParsed;
                }
            });
            this.props.setFilesGalleries(filesGalleries);
        } else if (!fileInfosParsed[0].elementId) {
            if (this.props.project) {
                let project = JSON.parse(JSON.stringify(this.props.project));
                fileInfosParsed.forEach(fileInfoParsed => {
                    const index = (project.fileInfos || []).findIndex(x => x.id === fileInfoParsed.id);
                    if (index !== -1) {
                        fileInfoParsed.url = FileInfosUtil.getUrl(fileInfoParsed);
                        project.fileInfos[index] = fileInfoParsed;
                    }
                });
                this.props.setProject(project);
            }

            if (this.props.projects?.length) {
                let projects = JSON.parse(JSON.stringify(this.props.projects));
                const index = projects.findIndex(x => x.id === fileInfosParsed[0].projectId);
                if (index !== -1)
                    fileInfosParsed.forEach(fileInfoParsed => {
                        const fiIndex = (projects[index].fileInfos || []).findIndex(x => x.id === fileInfoParsed.id);
                        if (fiIndex !== -1) {
                            fileInfoParsed.url = FileInfosUtil.getUrl(fileInfoParsed);
                            projects[index].fileInfos[fiIndex] = fileInfoParsed;
                        }
                    });
                this.props.setProjects(projects);
            }
        }
    }

    handleRemoveFileInfos = (idsParsed) => {
        if (this.props.project && this.props.photosGalleries && this.props.photosGalleries.find(x => idsParsed.includes(x.id)))
            this.props.setPhotosGalleries(this.props.photosGalleries.filter(x => !idsParsed.includes(x.id)));
        else if (this.props.project && this.props.filesGalleries && this.props.filesGalleries.find(x => idsParsed.includes(x.id)))
            this.props.setFilesGalleries(this.props.filesGalleries.filter(x => !idsParsed.includes(x.id)));
        else {
            if (this.props.project) {
                let project = JSON.parse(JSON.stringify(this.props.project));
                project.fileInfos = (project.fileInfos || []).filter(x => !idsParsed.includes(x.id));
                this.props.setProject(project);
            }

            if (this.props.projects?.length) {
                let projects = JSON.parse(JSON.stringify(this.props.projects));
                const index = projects.findIndex(x => x.fileInfos && x.fileInfos.find(fi => idsParsed.includes(fi.id)));
                if (index !== -1) {
                    projects[index].fileInfos = projects[index].fileInfos.filter(x => !idsParsed.includes(x.id));
                }
                this.props.setProjects(projects);
            }
        }
    }
}

const mapStateToProps = (state) => {
    return {
        project: state.project,
        projects: state.projects,
        rootBaseProjectIds: state.rootBaseProjectIds,
        projectCollaborators: state.projectCollaborators,
        filterLists: state.filterLists,
        customCharts: state.customCharts,
        organizationCustomFields: state.organizationCustomFields,
        customFieldCategories: state.customFieldCategories,
        themes: state.themes,
        priceLists: state.priceLists,
        photosGalleries: state.photosGalleries,
        filesGalleries: state.filesGalleries,
        formulas: state.formulas,
        userProjects: state.userProjects,
        activeOrganization: state.activeOrganization,
        organizations: state.organizations,
    };
};

const mapDispatchToProps = {
    setProject,
    setProjects,
    setRootBaseProjectIds,
    setPhotosGalleries,
    setFilesGalleries,
    setFilterLists,
    setCustomCharts,
    setOrganizationCustomFields,
    setCustomFieldCategories,
    setThemes,
    setPriceLists,
    setProjectCollaborators,
    setUserProjects,
    setActiveOrganization,
    setOrganizations,
};

export default connect(mapStateToProps, mapDispatchToProps)(GlobalWebSocket);